import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const jiraBusinessCalendarEmbedRoute: InvariantJiraRoute = {
	name: 'classic-business-calendar-embed',
	path: '/jira/core/projects/:projectKey/calendar/embed',
	exact: true,
};
